module.exports = __webpack_public_path__ + "static/media/download.7a971354.svg";